<template>
  <div class="home container">
    <div class="social-and-email">
      <a
        v-for="link in socialMediaLinks"
        :key="link.href"
        :href="link.href"
        :title="link.alt"
        class="social-media-link"
        target="_blank" rel="noopener noreferrer">
        <img class="social-media-link" :src="link.src" :alt="link.alt + ' icon'">
      </a>
      <div class="divider d-none d-md-flex">

      </div>
      <a class="email-link" target="_blank" rel="noopener noreferrer" href="mailto:dan.devorkin@gmail.com">
        <img class="email-icon" src="@/assets/homepage-mail.svg" alt="email icon">dan.devorkin@gmail.com
      </a>

    </div>
    <div class="main row no-gutters" @mousemove="handleMouseMove">
      <div class="col-md-6 order-md-2 self-portrait">
        <self-portrait
          :currentMouseX="currentMouseX"
          :currentMouseY="currentMouseY"
          :currentMouseMomentum="momentum"/>
      </div>
      <div class="col-md-6 align-self-center">
        <h1 class="title">Dan Devorkin</h1>
        <h2 class="subtitle">
          Full stack developer, product designer, {{ thirdThing }}.
        </h2>
        <a class="button" target="_blank" rel="noopener noreferrer" href="mailto:dan.devorkin@gmail.com">Get in touch!</a>
      </div>
    </div>
  </div>
</template>

<script>

import selfPortrait from '@/components/SelfPortrait'

export default {
  name: 'Home',
  components: {
    selfPortrait
  },
  data () {
    return {
      socialMediaLinks: [
        {
          alt: 'linkedin',
          href: 'https://www.linkedin.com/in/dan-devorkin/',
          src: require('../assets/homepage-linkedin.svg')
        },
        {
          alt: 'dribbble',
          href: 'https://dribbble.com/dandevorkin',
          src: require('../assets/homepage-dribbble.svg')
        },
        {
          alt: 'twitter',
          href: 'https://twitter.com/asap_devorkin',
          src: require('../assets/homepage-twitter.svg')
        },
        {
          alt: 'behance',
          href: 'https://www.behance.net/dandevorkin',
          src: require('../assets/homepage-behance.svg')
        },
        {
          alt: 'github',
          href: 'https://github.com/DanDog',
          src: require('../assets/homepage-github.svg')
        }
      ],
      thirdThings: [
        'tadpole collector',
        'meat popsicle',
        'beard haver' // enthusiast
      ],
      currentMouseX: 0,
      currentMouseY: 0,
      prevMouseX: 0,
      prevMouseY: 0,
      interval: null,
      thirdThing: '',
      momentumX: 0,
      momentumY: 0
    }
  },
  computed: {
    momentum () {
      const momentumX = Math.abs(this.prevMouseX - this.currentMouseX)
      const momentumY = Math.abs(this.prevMouseY - this.currentMouseY)
      return (momentumX + momentumY) / 2
    }
  },
  methods: {
    getImage (path) {
      return require(path)
    },
    handleMouseMove ($event) {
      const checkCursor = () => {
        this.prevMouseX = this.currentMouseX
        this.prevMouseY = this.currentMouseY
        this.currentMouseX = $event.clientX
        this.currentMouseY = $event.clientY
      }
      setTimeout(checkCursor, 300)
    }
  },
  mounted () {
    this.thirdThing = this.thirdThings[Math.floor(Math.random() * this.thirdThings.length)]
  }
}
</script>

<style lang="scss">

$text-n-such: #121212;
$text-n-such-lighter: #444444;

.home {
  height: 100vh;
  max-width: 1440px;
  padding-left: 10%;
  padding-right: 10%;
  padding-top: 2rem;
  background-color: #F7FAFC;
  color: $text-n-such;
}

.social-and-email {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.social-media-link {
  max-width: 18px;
  max-height: 18px;
  margin-right: 1rem;
  margin-bottom: 1rem;
}

.email-icon {
  max-width: 18px;
  max-height: 18px;
  margin-right: 1rem;
}

.email-link {
  color:  $text-n-such;
  font-weight: 600;
  line-height: 18px;
}

.divider {
  border-left-width: 2px;
  border-left-color: $text-n-such;
  border-left-style: solid;
  margin: 0 1rem 0 0.5rem;
  max-height: 18px;
}

.main {
  display: flex;
  flex-direction: row;
}

.col {

}

.title {
  font-weight: 600;
}

.subtitle {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.img-fluid {
  max-width: 100%;
}

.align-self-center {
  align-self: center;
}

.self-portrait {
  // padding: 10%;
}

.button {
  background: $text-n-such;
  border-radius: 8px;
  color: white;
  display: inline-flex;
  margin-right: .5rem;
  font-weight: 600;
  padding-bottom: calc(.5em - 1px);
  padding-left: 1em;
  padding-right: 1em;
  padding-top: calc(.5em - 1px);
  &:hover {
    text-decoration: none;
    color: white;
    background: $text-n-such-lighter;
  }
}

</style>
